var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.base_path + encodeURI(_vm.src),"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }